








import Vue from "vue";

export default Vue.extend({
  name: "NavigationButton",
  props: ["routeLink", "routeName"],
  methods: {
    routeChangeEmit() {
      this.$emit("clicked");
    }
  }
});
